import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import ExistingGameList from '@/components/hub/ExistingGameList.js';
import { CLIENT_ENV } from '@/config/envVars';
import weightTable from '@/const/weights/bestWeights.json';
import { GameContext } from '@/state/contexts';
import {
	getLocalGameManagerForGameId,
	getLocalKeyForGameId,
	getSinglePlayerGameList,
} from '@/util/localGameStorage';
import { logg } from '@/util/logg';
import { aiCheck } from '@lc/controller/ai_controller';
import { controller_game } from '@lc/controller/game';
import { createCurrPlayer } from '@lc/interface/currPlayer/factory';
// import { get, post } from '@/config/axiosConfig';
// import { socket } from '@/socket';
import { createGameManager } from '@lc/interface/gameManager/factory';
// import { resumeGame, startSinglePlayerGame } from '@lc/const/socketEvent';
import { GameManager } from '@lc/interface/gameManager/types';
import { createPlayerInit } from '@lc/interface/playerInit/factory';
import { createStateChangeEvent } from '@lc/interface/stateChangeEvent/factory';
import { heuristicScoreTotal } from '@lc/lib/ai_helper';

const SingleplayerLauncher = () => {
	const navigate = useNavigate();
	const {
		setCurrPlayer,
		setGameId,
		setInitState,
		setSinglePlayer,
		setStateChangeHistory,
		setStartGameBool,
	}: any = useContext(GameContext);

	const [singlePlayerName, setSinglePlayerName] = useState('Commas');
	const [singlePlayerColor, setSinglePlayerColor] = useState('yellow');

	const [gameList, setGameList] = useState([]);

	/*
	const [lobbyId, setLobbyId] = useState('');
	const defaultWeights = {
		f1: 100,
		f2: 10,

		b1: 50,
		b2: 10,

		cR: 5,
		cF: -5,

		pr: 10,
		dc: 20,

		seaC: -3,
		sumC: -3,

		aCA: 5,
		cCA: 25,
		cA: 2,
		cC: 2,

		numTurns: 5,
	}
		*/

	logg('weight table loaded');
	logg(weightTable);

	// const weightTable = Array.from(
	// 	{ length: 12 },
	// 	() => structuredClone(defaultWeights)
	// );

	useEffect(() => {
		async function getExistingGameList() {
			let tempGameList: any = await getSinglePlayerGameList();
			setGameList(tempGameList);
		}

		getExistingGameList();
	}, []);

	function setSinglePlayerGameState(gameManager: GameManager) {
		setCurrPlayer(gameManager.currPlayerLocal);
		setGameId(gameManager.gameId);
		setInitState(gameManager.gameState);
		setStateChangeHistory(gameManager.stateChangeHistory);
		setStartGameBool(true);
		setSinglePlayer(true);
	}

	// Take in # of bots from drop down
	// start game with that # of bots
	// save it to JSON
	// give list of all games stored in a JSON file
	// make start/resume single player game a component usable whether you are logged in or not
	// Use single player offline as baseline for TUTORIAL

	// ENTER FIELD FOR NAME
	// ENTER DROP DOWN FOR COLOR

	async function startSinglePlayerGameLocal(e, isFall = false) {
		e.preventDefault();
		setSinglePlayer(true);

		const stateChangeEvent = createStateChangeEvent();

		// get latest game_id (from JSON file of games)
		// make mock players

		let gameId = 0;

		for (let i = 0; i < localStorage.length; i++) {
			const key = localStorage.key(i);
			if (key) {
				const value = localStorage.getItem(key);
				logg(`${key}: ${value}`);
			}
			gameId++;
		}

		gameId++; // use next available game

		const localKey = getLocalKeyForGameId(gameId);

		const currPlayerObj = createCurrPlayer(
			singlePlayerColor,
			0,
			'' + gameId,
			singlePlayerName
		);

		let playerId = currPlayerObj.playerId || 0;

		const playerInit = createPlayerInit(
			playerId,
			0,
			gameId,
			currPlayerObj.color,
			currPlayerObj.pname
		);

		if (
			playerInit.pname.toLocaleLowerCase() === 'commas' ||
			playerInit.pname.toLocaleLowerCase() === 'sporp'
		) {
			playerInit.is_admin = true;
		}

		const dummy1 = createPlayerInit(1, 1000001, gameId, 'blue', 'dummy1');

		const dummy2 = createPlayerInit(2, 1000002, gameId, 'green', 'dummy2');

		const players = [playerInit, dummy1, dummy2];

		const gameState = isFall
			? await controller_game.startSinglePlayerFallGameLocal(
					gameId,
					players,
					stateChangeEvent
				)
			: await controller_game.startSinglePlayerGameLocal(
					gameId,
					players,
					stateChangeEvent
				);

		const stateChangeHistory = [stateChangeEvent];
		const gameManager = createGameManager(
			gameId,
			gameState,
			stateChangeHistory
		);

		gameManager.normalSeasonalWeights = weightTable;

		const playersInGameOrder = gameManager.gameState.playerStateArray;
		for (let i = 0; i < playersInGameOrder.length; i++) {
			if (currPlayerObj.pname === playersInGameOrder[i].username) {
				currPlayerObj.playerId = playersInGameOrder[i].playerId;
			}
		}

		gameManager.currPlayerLocal = currPlayerObj;

		await aiCheck(gameManager);

		setSinglePlayerGameState(gameManager);

		logg('** post single player game state **');
		logg(gameManager.gameState);
		logg('currPlayerObj');
		logg(currPlayerObj);

		const gameString = JSON.stringify(gameManager);
		localStorage.setItem(localKey, gameString);

		navigate(`/board3d?gameId=${gameId}&local=true`, { replace: true });
	}

	async function runGame(weightTable) {
		const stateChangeEvent = createStateChangeEvent();

		// get latest game_id (from JSON file of games)
		// make mock players

		let gameId = 0;

		for (let i = 0; i < localStorage.length; i++) {
			const key = localStorage.key(i);
			if (key) {
				const value = localStorage.getItem(key);
				logg(`${key}: ${value}`);
			}
			gameId++;
		}

		gameId++; // use next available game

		// const localKey = getLocalKeyForGameId(gameId);

		const currPlayerObj = createCurrPlayer(
			singlePlayerColor,
			0,
			'' + gameId,
			singlePlayerName
		);

		const dummy0 = createPlayerInit(1, 1000001, gameId, 'yellow', 'dummy0');
		const dummy1 = createPlayerInit(2, 1000002, gameId, 'blue', 'dummy1');
		const dummy2 = createPlayerInit(3, 1000003, gameId, 'green', 'dummy2');

		const players = [dummy0, dummy1, dummy2];

		const gameState = await controller_game.startSinglePlayerGameLocal(
			gameId,
			players,
			stateChangeEvent
		);

		const stateChangeHistory = [stateChangeEvent];
		const gameManager = createGameManager(
			gameId,
			gameState,
			stateChangeHistory
		);

		const playersInGameOrder = gameManager.gameState.playerStateArray;
		for (let i = 0; i < playersInGameOrder.length; i++) {
			if ('dummy0' === playersInGameOrder[i].username) {
				currPlayerObj.playerId = 0;
			}
		}

		gameManager.currPlayerLocal = currPlayerObj;

		gameManager.normalSeasonalWeights = weightTable;

		await aiCheck(gameManager);

		// setSinglePlayerGameState(gameManager);

		// const gameString = JSON.stringify(gameManager);
		// localStorage.setItem(localKey, gameString);

		if (gameManager.gameState.gameStatus === 2) {
			logg('COMPLETED GAME. WIN! 🥳');
		} else {
			logg('COMPLETED GAME. LOSE! 😔');
		}

		logg(gameManager.gameState);

		return gameManager;
	}

	async function runSimulation(e) {
		e.preventDefault();
		await runGame(weightTable);
	}

	// for loop to run the simulation 1000 times
	// randomize the weights a little bit each time
	// save the heighest scores, use them to seed the next round
	// keep goign

	// fix this, mutate weights per turn.
	// save best set, that's our guy

	async function runSimulationX1000(e, iterations = 25, batchSize = 10) {
		e.preventDefault();
		// 1. Define initial weights$
		let bestWeights = weightTable;

		let bestOverallScore = -Infinity;

		logg('🚀 Starting Weight Optimization...');

		for (let gen = 0; gen < iterations; gen++) {
			if (gen % 10 === 0) {
				await new Promise((resolve) => setTimeout(resolve, 0)); // let garbage collector run?
			}
			// 2. Mutate weights (Small random nudge)
			let candidateWeights: any = [];
			for (let i = 0; i < bestWeights.length; i++) {
				candidateWeights.push(mutateWeights(bestWeights[i], 0.1)); // 0.1 is mutation strength
			}

			// 3. Run a batch of simulations to reduce noise
			const scores: number[] = [];
			for (let b = 0; b < batchSize; b++) {
				let gameManager = await runGame(candidateWeights);
				const score = await heuristicScoreTotal(
					gameManager.gameState,
					candidateWeights[11]
				);
				scores.push(score);
				(gameManager as any) = null;

				// await new Promise(r => setTimeout(r, 1));
				// const score = Math.random();
			}

			const averageScore =
				scores.reduce((a, b) => a + b, 0) / scores.length;

			logg(
				`Gen ${gen}: Avg Score: ${averageScore.toFixed(2)} | Best: ${bestOverallScore.toFixed(2)}`
			);

			// 4. Selection: If this mutation is better, make it the new baseline
			if (averageScore > bestOverallScore) {
				bestOverallScore = averageScore;
				bestWeights = candidateWeights;
				logg('✅ New best weights found!');
			}
		}
		logg('bestOverallScore ' + bestOverallScore);

		function downloadJSON(data: any, filename = 'bestWeights.json') {
			const json = JSON.stringify(data, null, 2);

			const blob = new Blob([json], { type: 'application/json' });
			const url = URL.createObjectURL(blob);

			const a = document.createElement('a');
			a.href = url;
			a.download = filename;
			a.click();

			URL.revokeObjectURL(url);
		}

		downloadJSON(bestWeights);

		logg('Saved bestWeights.json');

		return bestWeights;
	}

	// Helper: Randomly nudges weights
	function mutateWeights(weights, strength) {
		const newWeights = { ...weights };
		const keys = Object.keys(newWeights);

		for (let key of keys) {
			// if(key in ['season', 'win', 'winDono']){
			// 	continue;
			// }
			const noise = (Math.random() * 2 - 1) * strength; // Random value between -strength and +strength
			newWeights[key] += noise * (Math.abs(newWeights[key]) + 1); // Scale noise to weight magnitude
		}
		return newWeights;
	}

	// TODO make this work for pulling a JSON file and setting any necessary hooks
	// TODO I need: Can all be retrieved via a rest call & set to hooks before nav to game:
	// 1) currPlayer
	// 2) players array
	// 3) game state
	// Also, a connection array to display who is in the game and who is connected or not would be chill
	// so, players in an array with their id, and a confirm or deny if connected or not
	async function navToExistingGame(e, gameId) {
		// GET ALL CURR PLAYER DATA AND STATE THEN NAV TO BOARD3D, OR GRAB STATE FROM QUERY?! OR MAKE THE CONTEXT AND A CONTEXT DECOUPLER
		e.preventDefault();

		const gameManager = getLocalGameManagerForGameId(gameId);

		setSinglePlayerGameState(gameManager);

		navigate(`/board3d?gameId=${gameId}&local=true`, { replace: true }); //?gameId=${lobbyId}
	}

	return (
		<div className="titleContainer">
			<div className="login-form">
				<label>
					<p>Single Player</p>
				</label>
				<label>
					<input
						type="text"
						onChange={(e) => setSinglePlayerName(e.target.value)}
						placeholder="Enter Your Name"
					/>
				</label>
				<button onClick={(e) => startSinglePlayerGameLocal(e)}>
					Start Single Player Game
				</button>

				{CLIENT_ENV === 'DEV' && (
					<button
						onClick={(e) => startSinglePlayerGameLocal(e, true)}
					>
						Start Single Player Fall Game
					</button>
				)}
				{CLIENT_ENV === 'DEV' && (
					<button onClick={(e) => runSimulation(e)}>
						Run Simulation
					</button>
				)}
				{CLIENT_ENV === 'DEV' && (
					<button onClick={(e) => runSimulationX1000(e)}>
						Run Simulation x1000
					</button>
				)}
			</div>

			{gameList.length > 0 && (
				<div className="login-form">
					<p>Previous Single Player Games</p>
					<ExistingGameList
						gameList={gameList}
						navToExistingGame={navToExistingGame}
					/>
				</div>
			)}
		</div>
	);
};

export default SingleplayerLauncher;
